import { combineEpics } from "redux-observable";
import DataSourceDuplicateEpic from "./DataSourceDuplicateEpic.js";
import DataSourceFlightFormatsEpic from "./DataSourceFlightFormatsEpic.js";
import DataSourceCreateEpic from "./DataSourceCreateEpic.js";
import DataSourceUpdateEpic from "./DataSourceUpdateEpic.js";
import ServicePrincialListEpic from "./ServicePrincipalListEpic.js";
import ManagedIdentityListEpic from "./ManagedIdentityList.js";
const rootEpic = combineEpics(
  DataSourceCreateEpic,
  DataSourceDuplicateEpic,
  DataSourceFlightFormatsEpic,
  DataSourceUpdateEpic,
  ServicePrincialListEpic,
  ManagedIdentityListEpic
);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
